import type { PluginSkillPermissions } from "@cmmd-forge/contracts/settings";
import { resolvePluginSkillEnabled } from "@cmmd-forge/shared/computerUsePermission";

import type { ForgePluginId } from "./pluginsPage.logic";

/**
 * Resolved through the shared module rather than re-deriving `!== false` here.
 * Computer use is opt-in on the server; if this file kept its own default the
 * toggle would render "on" while the server treated it as off, telling the user
 * an agent cannot control their machine when it can.
 */
export function isPluginSkillEnabled(
  permissions: PluginSkillPermissions,
  pluginId: ForgePluginId,
  skillId: string,
): boolean {
  return resolvePluginSkillEnabled(permissions, pluginId, skillId);
}

export function setPluginSkillEnabled(
  permissions: PluginSkillPermissions,
  pluginId: ForgePluginId,
  skillId: string,
  enabled: boolean,
): PluginSkillPermissions {
  return {
    ...permissions,
    [pluginId]: {
      ...permissions[pluginId],
      [skillId]: enabled,
    },
  };
}

export function setPluginSkillsEnabled(
  permissions: PluginSkillPermissions,
  pluginId: ForgePluginId,
  skillIds: readonly string[],
  enabled: boolean,
): PluginSkillPermissions {
  const nextPluginPermissions = { ...permissions[pluginId] };
  for (const skillId of skillIds) {
    nextPluginPermissions[skillId] = enabled;
  }
  return {
    ...permissions,
    [pluginId]: nextPluginPermissions,
  };
}
